import { FormattedMessage } from 'react-intl';
import './ImageVerificatorSkeleton.css';

export default function ImageVerificatorSkeleton() {
	return (
		<div className="image-verificator image-verificator-skeleton">
			<h2>
				<FormattedMessage id="sentinel.image-verification.title" />
			</h2>
			<div id="slider-skeleton">
				<div className="slides-container-skeleton">
					<div className="image-verification-card">
						{Array.from({ length: 4 }).map((_, index) => (
							<div key={index} className="image-wrapper skeleton-element" />
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
